import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  dots: {
    borderBottom: "1px dashed black",
    flexGrow: 1,
  },
}));
